import React   from 'react';
import numeral from 'numeral';

import RadioComponent from 'pu-react/components/base/RadioComponent';

export default (props) => {
  if (!props.showSummary) {
    return null;
  }
  const groupName = `items[${props.itemId}]`
  // var totals = [];
  // var row = 0;
  const totals = Object.keys(props.quote.totals).map((key, row) => (
    <tr key={"total-" + key}>
      <td className="qty"> {key} </td>
      <td>
        <RadioComponent
          inputId={`price-${key}-${row}-parts`}
          label={`$${numeral(props.quote.totals[key]/parseInt(key)).format('0.00')}`}
          name='price_matrix'
          groupName={groupName}
          inline
          onChange={e => props.onPriceSelect({
            selected_quantity: key,
            row_selected: (row),
            column_selected: 0,
          })}
          checked={props.selected_quantity == key && true} />
      </td>
    </tr>
  ))
  // Object.entries(props.quote.totals).forEach(([key, value]) => {
  //   totals.push(
  //     <tr key={"total-" + key}>
  //       <td className="qty"> {key} </td>
  //       <td>
  //         <RadioComponent
  //           inputId={`price-${key}-${row}-parts`}
  //           label = {`$${numeral(value).format('0.00')}`}
  //           name='price_matrix'
  //           groupName={groupName}
  //           inline
  //           onChange = {e => props.onPriceSelect({ selected_quantity: key,
  //                                                  row_selected     : (row),
  //                                                  column_selected  : 0,
  //                                               })}
  //           checked={props.selected_quantity == key && true } />
  //       </td>
  //     </tr>
  //   )
  //   row += 1;
  // });

  return (
    <table className="table table-bordered table-price-matrix">
      <thead>
        <tr>
          <th className="qty">Qty</th>
          <th className="qty">TOTAL PRICE</th>
        </tr>
      </thead>
      <tbody>
        {totals}
      </tbody>
    </table>
  );
};
